import { isValidElement } from "react";
import { isPlainObject } from "../../utils/index.js";
import { SectionItem } from "./SectionItem.js";
function isValidSectionItem(value) {
  if (!isValidElement(value)) return false;
  if (value.type !== SectionItem) return false;
  const item = value.props;
  if (!isPlainObject(item)) return false;
  if (!item.hasOwnProperty("children")) return false;
  let pinned;
  if (item.hasOwnProperty("pinned")) {
    if (typeof item.pinned !== "string" && typeof item.pinned !== "undefined") return false;
    pinned = item.pinned;
  }
  const { children } = item;
  const obj = { children, pinned };
  const isValid = obj;
  const noNewOptionalProps = {};
  return !!isValid && !!noNewOptionalProps;
}
export {
  isValidSectionItem
};
//# sourceMappingURL=guards.js.map
